<template>
    <div class="inner-modal-content">
        <form class="add-order" id="informations-form" @submit.prevent="saveOrder()">
            <input type="hidden" id="submit_type" value="save">
            <div class="form-row">
                <div class="form-group form-col-1" v-if="checkModulePermission('digital_menu')">
                    <label for="mesa">Mesa vinculada</label>
                    <input type="number" name="mesa" id="mesa" v-model="order.mesa" :disabled="isAppOrder" placeholder="Nº da mesa">
                </div>
                <div class="form-group" :class="checkModulePermission('digital_menu') ? 'form-col-3' : 'form-col-4'">
                    <label for="id_cliente">Nome do cliente</label>
                    <div :style="isAppOrder ? 'pointer-events: none; opacity: 0.6;' : ''">
                        <ajaxAutoComplete @select="setCustomer($event)" ajaxtype="clientes" :entityid="order.id_cliente"
                            :entityname="order.nome_cliente" :required="true" />
                    </div>
                </div>
            </div>
            <input type="submit" id="submit-button" style="display: none;">
        </form>
        <div class="order-dishes-container">
            <div class="order-dishes-header">
                <h3>Itens do pedido</h3>
                <div class="order-dishes-actions" v-if="canMutateOrder">
                    <button type="button" class="btn btn-sm btn-primary" v-on:click="addDish()">
                        <span class="material-icons" style="font-size: 16px; margin-right: 4px;">add</span> Adicionar item
                    </button>
                    <div class="dynamic-edit-buttons">
                        <button type="button" class="btn btn-sm btn-danger" v-on:click="excludeDish()">
                            <span class="material-icons" style="font-size: 16px; margin-right: 4px;">delete</span> Excluir
                        </button>
                    </div>
                </div>
            </div>
            <p class="app-order-readonly-notice" v-if="isAppOrder">
                Pedido recebido pelo app: itens e pagamentos são somente leitura neste sistema.
            </p>
            <dataTable :dataobj="order.dishes" rowsperpage="3" searchText="" :loaded="contentLoaded">
                <grid-column prop="id" label="Cód." width="70px" align="center" v-slot="props">
                    <p class="clicable text-center" @click="selectRow($event)">{{ props.item.id }}</p>
                </grid-column>
                <grid-column prop="nome" label="Nome do Item"></grid-column>
                <grid-column prop="quantidade" label="Qtd" width="80px" align="center" v-slot="props">
                    <p class="text-center">{{ formatDishQuantity(props.item) }}</p>
                </grid-column>
                <grid-column prop="observacoes" label="Observações" width="160px" v-slot="props">
                    <span class="order-observation-cell" :title="getDishObservationTitle(props.item)">
                        {{ truncateText(formatDishObservationGrid(props.item), 35) }}
                    </span>
                </grid-column>
                <grid-column prop="preco" label="Valor" width="100px"></grid-column>
                <grid-column prop="status" label="Status" width="100px"></grid-column>
            </dataTable>
        </div>
        <div class="order-cancelled-dishes-container" v-if="order.cancelled_dishes && order.cancelled_dishes.length">
            <h3>Itens cancelados</h3>
            <div class="cancelled-dish-row" v-for="dish in order.cancelled_dishes" :key="dish.id + '-' + dish.cancelado_em">
                <span class="cancelled-dish-badge">CANCELADO</span>
                <span class="cancelled-dish-name">{{ dish.nome }} ({{ formatDishQuantity(dish) }})</span>
                <span class="cancelled-dish-reason">{{ dish.motivo_cancelamento || "Motivo não informado" }}</span>
            </div>
        </div>
        <div class="order-submit-informations" v-if="payment != false">
            <div class="payment-card">
                <div class="payment-actions">
                    <button class="btn btn-primary" type="button" v-if="canMutateOrder" v-on:click="openPaymentModal()">
                        <span class="material-icons" style="font-size: 16px; margin-right: 4px;">payments</span> Pagamento
                    </button>
                </div>
                <div class="payment-breakdown">
                    <div class="breakdown-item"><span class="breakdown-label">Pix:</span> <span class="breakdown-val">{{ pix_payment }}</span></div>
                    <div class="breakdown-item"><span class="breakdown-label">Cartão:</span> <span class="breakdown-val">{{ card_payment }}</span></div>
                    <div class="breakdown-item"><span class="breakdown-label">Dinheiro:</span> <span class="breakdown-val">{{ cash_payment }}</span></div>
                    <div class="breakdown-item"><span class="breakdown-label">Desconto:</span> <span class="breakdown-val">{{ total_desconto }}</span></div>
                    <div class="breakdown-item" v-if="checkModulePermission('shipping')"><span class="breakdown-label">Entrega:</span> <span class="breakdown-val">{{ delivery_amount }}</span></div>
                    <div class="breakdown-item font-bold"><span class="breakdown-label">Restante:</span> <span class="breakdown-val">{{ difference }}</span></div>
                </div>
                <div class="order-total-box">
                    <span class="total-label">Total a pagar</span>
                    <h2 class="order-total-amount">{{ order.total }}</h2>
                </div>
            </div>
            <div class="delivery" v-if="checkModulePermission('shipping') && false">
                <button class="btn btn-secondary">Entrega</button>
                <div class="delivery-content">
                    <div class="delivery-texts">
                        <h3>Rua Brasholanda, 556 - Weissópolis, Pinhais</h3>
                        <h3>Cep: 86930-000</h3>
                    </div>
                </div>
            </div>
        </div>
        <div class="small-modal" id="modal-dishes" v-if="canMutateOrder">
            <form class="add-dish" id="informations-form" @submit.prevent="submitAddDish()">
                <div class="form-group">
                    <label for="item">Item</label>
                    <select name="item" id="item" required @change="selectThisDish()">
                        <option value="">* Selecione *</option>
                        <option :value="item.id" v-for="(item, index) in dishes_list" :key="index">{{ item.nome }} {{
                            item.disponivel == 1 ? "" : "(Indisponível)" }}</option>
                    </select>
                </div>
                <div class="form-group">
                    <label for="quantidade">Quantidade {{ selectedDishUnitLabel }}</label>
                    <input type="number" name="quantidade" v-model="quantity" id="quantidade" :step="selectedDishQuantityStep" :min="selectedDishQuantityMin" inputmode="decimal" required>
                </div>
                <div class="form-group">
                    <label for="observacoes">Observações</label>
                    <input type="text" name="observacoes" v-model="observations" id="observacoes">
                </div>
                <button type="submit" class="btn btn-primary w-100">Salvar</button>
            </form>
        </div>
        <div class="small-modal" id="modal-payment" v-if="canMutateOrder">
            <form class="add-payment" id="informations-form" @submit.prevent="submitAddPayment()">
                <div class="form-group">
                    <label for="metodo_pagamento">Método de pagamento</label>
                    <select name="metodo_pagamento" id="metodo_pagamento" required>
                        <option value="">* Selecione *</option>
                        <option value="dinheiro">Dinheiro</option>
                        <option value="cartao">Cartão</option>
                        <option value="pix">Pix</option>
                    </select>
                </div>
                <div class="form-group">
                    <label for="valor_pago">Valor pago</label>
                    <input type="text" name="valor_pago" id="valor_pago" v-model="amount_payed" required>
                </div>
                <button type="submit" class="btn btn-primary w-100">Adicionar</button>
            </form>
        </div>
        <div class="small-modal-wrapper" v-on:click="closeSmallModal()"></div>
        <p class="response big">{{ response }}</p>
    </div>
</template>
<script>
import api from "../../../configs/api";
import { globalMethods } from "@/js/globalMethods";
import $ from 'jquery';
import dataTable from "../../dataTable.vue";
import ajaxAutoComplete from "../../ajaxAutoComplete.vue";

export default {
    name: "editOrderModalContent",
    mixins: [globalMethods],
    props: ["orderid", "payment"],
    data() {
        return {
            savingOrder: false,
            order: {
                dishes: [],
                cancelled_dishes: [],
                total: "R$ 0,00",
                nome_cliente: "",
                id_cliente: "",
                mesa: "",
                zip_code: null,
                address: null,
                number: null,
                complement: null,
                address_name: null,
                state: null,
                city: null,
                from_app: 0
            },
            dishes_list: [],
            selected_dish: [],
            quantity: null,
            order_total: null,
            observations: "",
            delivery_amount: "R$ 0",
            card_payment: "R$ 0",
            cash_payment: "R$ 0",
            pix_payment: "R$ 0",
            amount_payed: "R$ 0",
            accumulatedQuantity: 0,
            cliente_nome: "",
            cliente_id: "",
            cliente_desconto: 0,
            total_desconto: "R$ 0",
            frozen_table: null
        }
    },
    computed: {
        total_amout() {
            let total = (this.formatDecimalValues(this.card_payment) + this.formatDecimalValues(this.cash_payment) + this.formatDecimalValues(this.pix_payment));
            return total;
        },
        difference() {
            let order_total = this.formatDecimalValues(this.order.total);
            let difference = order_total - this.total_amout;

            return difference.toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            });
        },
        isAppOrder() {
            return Number(this.order?.from_app) === 1;
        },
        canMutateOrder() {
            if (this.orderid == null) {
                return true;
            }

            return this.contentLoaded && !this.isAppOrder;
        },
        selectedDishIsBulk() {
            return Number(this.selected_dish?.a_granel) === 1;
        },
        selectedDishQuantityStep() {
            return this.selectedDishIsBulk ? "0.001" : "1";
        },
        selectedDishQuantityMin() {
            return this.selectedDishIsBulk ? "0.001" : "1";
        },
        selectedDishUnitLabel() {
            if (this.selectedDishIsBulk && this.selected_dish?.unidade_medida_granel) {
                return `(${this.selected_dish.unidade_medida_granel})`;
            }

            return "";
        }
    },
    watch: {
        order_total: function () {
            this.calculateOrderTotal();
        },
        amount_payed: function () {
            var valor = this.amount_payed.replace(/\D/g, '');

            var valorNumerico = parseInt(valor) / 100;

            var valorFormatado = valorNumerico.toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            });

            this.amount_payed = valorFormatado;
        }
    },
    methods: {
        rejectAppOrderMutation: function () {
            if (!this.isAppOrder) {
                return false;
            }

            this.closeSmallModal();
            this.setResponse("Pedidos feitos pelo app não permitem alteração de itens ou pagamentos", "error");
            return true;
        },
        normalizeDishQuantity: function (quantity, dish = {}) {
            let normalizedQuantity = parseFloat(quantity);

            if (isNaN(normalizedQuantity) || normalizedQuantity <= 0) {
                return 0;
            }

            return dish.a_granel == 1 ? normalizedQuantity : parseInt(normalizedQuantity);
        },
        formatDishQuantity: function (dish) {
            let quantity = parseFloat(dish.quantidade || dish.quantity || 0);

            if (dish.a_granel == 1) {
                return `${quantity.toLocaleString('pt-BR', { maximumFractionDigits: 3 })} ${dish.unidade_medida_granel || ""}`.trim();
            }

            return parseInt(quantity);
        },
        truncateText: function (text, maxChars = 35) {
            let normalizedText = text == null ? "" : text.toString();
            let limit = parseInt(maxChars);

            if (!limit || normalizedText.length <= limit) {
                return normalizedText;
            }

            if (limit <= 3) {
                return normalizedText.substring(0, limit);
            }

            return `${normalizedText.substring(0, limit - 3).trimEnd()}...`;
        },
        formatDishObservationGrid: function (dish) {
            let observations = dish?.observacoes == null ? "" : dish.observacoes.toString().trim();

            if (observations == "") {
                return "";
            }

            if (dish?.a_granel == 1) {
                return observations;
            }

            let dishQuantity = parseInt(this.normalizeDishQuantity(dish.quantidade || dish.quantity || 0, dish));

            if (!dishQuantity || dishQuantity <= 0) {
                return observations;
            }

            return observations
                .split(",")
                .map((observation) => observation.trim())
                .filter((observation) => observation != "")
                .map((observation) => {
                    let quantityPrefix = observation.match(/^(\d+)\s+(.+)$/);

                    if (!quantityPrefix) {
                        return observation;
                    }

                    let observationQuantity = parseInt(quantityPrefix[1]);
                    let observationText = quantityPrefix[2].trim();

                    if (observationQuantity === dishQuantity || observationQuantity === 1) {
                        return observationText;
                    }

                    return `${observationQuantity} ${observationText}`;
                })
                .join(", ");
        },
        getDishObservationTitle: function (dish) {
            let observation = this.formatDishObservationGrid(dish);

            return observation.length > 35 ? observation : null;
        },
        dishPriceFactor: function (dish) {
            if (dish?.a_granel != 1) {
                return 1;
            }

            let factor = parseFloat(dish.fator_preco_granel || 1);

            return factor > 0 ? factor : 1;
        },
        dishLineTotal: function (dish, quantity = null) {
            let price = this.formatDecimalValues(dish.preco) || 0;
            let dishQuantity = quantity == null ? this.normalizeDishQuantity(dish.quantidade || dish.quantity, dish) : this.normalizeDishQuantity(quantity, dish);

            return Math.round(((price * dishQuantity) / this.dishPriceFactor(dish)) * 100) / 100;
        },
        calculateOrderTotal: function () {
            let total = this.order_total;
            let desconto = ((parseInt(this.cliente_desconto) / 100) * total).toFixed(2);
            let totalWithDiscount = total - desconto;

            this.total_desconto = this.formatCurrency(desconto);
            this.order.total = this.formatCurrency(totalWithDiscount);
        },
        setCustomer: function (event) {
            this.cliente_desconto = event.porcentagem_desconto != undefined && event.porcentagem_desconto != "" ? event.porcentagem_desconto.replace("%", "") : 0;
            this.cliente_nome = event.nome;
            this.cliente_id = event.id;
            this.calculateOrderTotal();
        },
        openPaymentModal: function () {
            if (this.rejectAppOrderMutation()) return;

            this.openSmallModal("#modal-payment");
        },
        addDish: function () {
            if (this.rejectAppOrderMutation()) return;

            this.openSmallModal("#modal-dishes");
        },
        excludeDish: function () {
            if (this.rejectAppOrderMutation()) return;

            let self = this;

            let excludedDish = self.order.dishes.find(obj => obj.id == self.editId);

            self.order.dishes = self.order.dishes.filter(obj => obj.id !== self.editId);
            let item_value = this.dishLineTotal(excludedDish);

            this.order_total -= item_value;
            this.editId = null;

            this.closeSmallModal();
        },
        reorganizeDishesObservations: function () {
            for (let i = 0; i < this.order.dishes.length; i++) {
                this.order.dishes[i].observacoes = this.groupObservations(this.order.dishes[i].observacoes);
            }
        },
        submitAddDish: function () {
            if (this.rejectAppOrderMutation()) return;

            let self = this;

            this.selectThisDish();
            this.resetResponse();
            let requestedQuantity = this.normalizeDishQuantity(this.quantity, this.selected_dish);

            if (requestedQuantity <= 0 || this.selected_dish.disponivel != 1) {
                this.disposeSelectedDishAndCloseSmallModal();
                return;
            }

            let sameDish = this.order.dishes.filter(dish => dish.id == this.selected_dish.id);
            let dishObservations = sameDish.length > 0 ? sameDish[0].observacoes : null;

            if (dishObservations != null && dishObservations.trim() != "") {
                dishObservations += ", " + this.observations;
            } else {
                let observationRepeats = this.selected_dish.a_granel == 1 ? 1 : parseInt(requestedQuantity);

                for (let i = 0; i < observationRepeats; i++) {
                    if (i == 0) {
                        dishObservations = this.observations;
                    } else {
                        dishObservations += ", " + this.observations;
                    }
                }
            }

            let gridDishObservations = this.groupObservations(dishObservations);

            let newDishGrid = {
                id: this.selected_dish.id,
                nome: this.selected_dish.nome,
                quantidade: requestedQuantity,
                observacoes: gridDishObservations,
                preco: this.selected_dish.preco,
                status: "Preparando",
                a_granel: this.selected_dish.a_granel,
                unidade_medida_granel: this.selected_dish.unidade_medida_granel,
                unidade_preco_granel: this.selected_dish.unidade_preco_granel,
                fator_preco_granel: this.selected_dish.fator_preco_granel
            }

            let selectedDishHaveInGrid = this.order.dishes.some(obj => obj.id == this.selected_dish.id);

            let accumulatedQuantity = requestedQuantity;

            if (this.order.dishes.length != 0 && selectedDishHaveInGrid) {
                this.order.dishes.map(obj => {
                    if (obj.id == this.selected_dish.id) {
                        accumulatedQuantity = this.normalizeDishQuantity(obj.quantidade, obj) + requestedQuantity;
                    }
                })
            }

            let data = {
                id: this.selected_dish.id,
                quantidade: accumulatedQuantity
            }

            api.post("/products/quantity_avalilable", data).then(() => {
                if (self.order.dishes.length == 0 || !selectedDishHaveInGrid) {
                    self.order.dishes.push(newDishGrid);
                } else {
                    self.order.dishes.map(obj => {
                        if (obj.id == this.selected_dish.id) {
                            obj.quantidade = accumulatedQuantity;
                            obj.observacoes = gridDishObservations;
                        }
                    })

                    self.order.dishes.push({});
                    self.order.dishes.pop();
                }

                let total_value = self.dishLineTotal(newDishGrid, requestedQuantity);
                self.order_total += total_value;

                self.observations = "";
            }).catch((error) => {
                this.setResponse(error.response.data, "error");
            }).then(() => {
                this.disposeSelectedDishAndCloseSmallModal();
            })
        },
        disposeSelectedDishAndCloseSmallModal: function () {
            this.selected_dish = {};
            this.quantity = null;

            this.closeSmallModal();
        },
        submitAddPayment: function () {
            if (this.rejectAppOrderMutation()) return;

            let metodoPagamento = $("#metodo_pagamento").val();
            let amountPayed = this.amount_payed;

            switch (metodoPagamento) {
                case "dinheiro":
                    this.cash_payment = amountPayed;
                    break;
                case "cartao":
                    this.card_payment = amountPayed;
                    break;
                case "pix":
                    this.pix_payment = amountPayed;
                    break;
            }

            this.amount_payed = "R$ 0";
            this.closeSmallModal();
        },
        selectThisDish: function () {
            let value = $("#item").val();

            let dish = this.dishes_list.find(obj => obj.id == parseInt(value));

            if (dish != undefined && dish != null) {
                this.selected_dish = dish;
            } else {
                this.selected_dish = {};
            }
        },
        saveOrder: function () {
            let self = this;
            if (self.savingOrder) return;
            if (self.isAppOrder) {
                self.setResponse("Pedidos feitos pelo app não podem ser editados ou finalizados manualmente nesta tela", "error");
                return;
            }
            if ($("#submit_type").val() == "save" && self.rejectAppOrderMutation()) return;

            let promises = [];

            this.resetResponse();

            let validTable = false;

            if (self.order.mesa != null) {
                promises.push(
                    api.get("/tables/valid_table/" + self.order.mesa).then((response) => {
                        if (response.data.returnObj || self.payment != false && self.order.mesa == "") {
                            validTable = true;
                        }
                    })
                )
            } else {
                promises.push(
                    new Promise((resolve) => {
                        resolve();
                    })
                )
            }

            let sameTable = self.frozen_table == self.order.mesa ? true : false;

            Promise.all(promises).then(() => {
                if (this.order.status == "Cancelado" || this.order.status == "Finalizado") {
                    self.$emit("savedContent", true);
                    return;
                }

                if (!validTable && !sameTable) {
                    this.setResponse("Número da mesa não existe ou ja está em uso", "error");
                    return;
                }

                if (this.order.dishes.length == 0) {
                    this.setResponse("O pedido não pode estar vazio", "error");
                    return;
                }

                if ($("#submit_type").val() == "finish" && this.formatDecimalValues(this.difference) != 0) {
                    this.setResponse("O pedido possui valor em aberto", "error");
                    return;
                }

                if ($(".ajax-autocomplete").attr("invalid") == "true") {
                    this.setResponse("Campo cliente não pode ser vazio", "error");
                    return;
                }

                self.savingOrder = true;

                let data = $("#informations-form").serializeArray().reduce(function (obj, item) { // Pega todos os dados do formulário e coloca em um objeto.
                    obj[item.name] = item.value;
                    return obj;
                }, {});

                data["pratos"] = self.order.dishes;
                data["pagamento_pix"] = this.pix_payment;
                data["pagamento_cartao"] = this.card_payment;
                data["pagamento_dinheiro"] = this.cash_payment;
                data["zip_code"] = this.order.zip_code;
                data["address"] = this.order.address;
                data["number"] = parseInt(this.order.number);
                data["complement"] = this.order.complement;
                data["address_name"] = this.order.address_name;
                data["state"] = this.order.state;
                data["city"] = this.order.city;
                data["mesa"] = this.order.mesa == "" ? null : parseInt(this.order.mesa);
                data["save_type"] = $("#submit_type").val();
                data["cliente_nome"] = this.cliente_nome != null ? this.cliente_nome : $("#ajax-autocomplete-input").val();
                data["cliente_id"] = this.cliente_id;

                let path = "new_order";

                if (self.orderid != null) {
                    path = "edit_order/" + self.orderid;
                }

                api.post("/orders/" + path, data).then(() => {
                    self.$emit("savedContent", true);
                }).catch((error) => {
                    self.setResponse(error.response.data, "error");
                }).then(() => {
                    self.savingOrder = false;
                })
            })
        },
        returnAllDishes: function () {
            let self = this;

            api.get("/products").then((response) => {
                self.dishes_list = response.data.returnObj;
            }).catch((error) => {
                console.log(error);
            })
        },
        returnOrder: function () {
            let self = this;

            if (self.orderid == null) {
                self.contentLoaded = true;
                self.order.dishes = [];
                return;
            }

            self.contentLoaded = false;

            api.get("/orders/" + self.orderid).then((response) => {
                self.contentLoaded = true;

                self.order = {
                    ...response.data.returnObj,
                    from_app: Number(response.data.returnObj?.from_app) === 1 ? 1 : 0
                };

                setTimeout(() => {
                    if (self.isAppOrder) {
                        $("#modal-submit-button").hide();
                        $("#modal-save-submit-button").hide();
                    } else {
                        $("#modal-submit-button").show();
                        $("#modal-save-submit-button").show();
                    }
                }, 10);

                self.order_total = self.order.total == null ? 0.0 : self.formatDecimalValues(self.order.total);
                self.pix_payment = self.formatCurrency(self.order.pagamento_pix);
                self.card_payment = self.formatCurrency(self.order.pagamento_cartao);
                self.cash_payment = self.formatCurrency(self.order.pagamento_dinheiro);
                self.cliente_nome = self.order.nome_cliente;
                self.cliente_id = self.order.id_cliente;
                self.cliente_desconto = self.order.porcentagem_desconto;

                self.delivery_amount = self.formatCurrency(self.order.valor_entrega || 0);

                let originalObj = self.order;
                let frozenObj = JSON.parse(JSON.stringify(originalObj));

                Object.freeze(frozenObj);

                self.frozen_table = frozenObj.mesa == '' ? null : frozenObj.mesa;

                self.calculateOrderTotal();
                self.reorganizeDishesObservations();
            }).catch((error) => {
                console.log(error);
            })
        }
    },
    mounted: function () {
        this.returnAllDishes();
        this.returnOrder();

        if (this.payment == false) {
            $("#mesa").attr("required", "required");
        }
    },
    components: {
        dataTable,
        ajaxAutoComplete
    }
}
</script>
<style scoped>
.order-dishes-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: var(--space-2);
}

.order-dishes-header h3 {
    margin: 0;
    font-size: 15px;
    font-weight: 700;
}

.order-dishes-actions {
    display: flex;
    align-items: center;
    gap: var(--space-2);
}

.btn-sm {
    padding: 6px 14px;
    font-size: 13px;
    min-width: auto;
    height: 36px;
    display: inline-flex;
    align-items: center;
}

.payment-card {
    background: var(--paper);
    border: 1px solid var(--line);
    border-radius: var(--radius-md);
    padding: var(--space-4) var(--space-5);
    margin-top: var(--space-4);
    display: grid;
    grid-template-columns: auto 1fr auto;
    gap: var(--space-5);
    align-items: center;
}

@media (max-width: 768px) {
    .payment-card {
        grid-template-columns: 1fr;
        gap: var(--space-3);
    }
}

.payment-breakdown {
    display: flex;
    flex-wrap: wrap;
    gap: 8px 16px;
    font-size: 13px;
}

.breakdown-item {
    display: flex;
    gap: 6px;
}

.breakdown-label {
    color: var(--ink-soft);
}

.breakdown-val {
    font-weight: 700;
    color: var(--ink);
}

.order-total-box {
    text-align: right;
    background: var(--surface);
    padding: 8px 16px;
    border-radius: var(--radius-sm);
    border: 1px solid var(--line);
}

.total-label {
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: var(--ink-soft);
    font-weight: 700;
    display: block;
}

.order-total-amount {
    margin: 2px 0 0 0;
    font-size: 20px;
    font-weight: 800;
    color: var(--cor-destaque);
}

.modal-body .custom-grid-container {
    max-height: 160px;
}

.order-observation-cell {
    display: inline-block;
    max-width: 180px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: middle;
}

.app-order-readonly-notice {
    margin: var(--space-3) 0;
    padding: var(--space-3) var(--space-4);
    border-radius: var(--radius-sm);
    background: var(--gray-3);
    font-weight: 600;
}

.order-cancelled-dishes-container {
    margin-top: var(--space-4);
}

.cancelled-dish-row {
    display: flex;
    align-items: center;
    gap: var(--space-3);
    padding: var(--space-2) 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
    opacity: 0.75;
}

.cancelled-dish-badge {
    flex-shrink: 0;
    padding: 2px 8px;
    border-radius: 10px;
    font-size: 0.72rem;
    font-weight: 700;
    background: #fdecea;
    color: #8b1f18;
    border: 1px solid #f5c2c0;
}

.cancelled-dish-name {
    text-decoration: line-through;
}

.cancelled-dish-reason {
    font-size: 0.85rem;
    opacity: 0.85;
}
</style>
